export default __webpack_public_path__ + "static/media/project1-p1.3dd68b25.png";